import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';

@Component({
  selector: 'app-wizardpage-step9-workhistory',
  templateUrl: './wizardpage-step9.component.html',
  styleUrls: ['./wizardpage-step9.component.scss']
})
export class WizardpageStep9WorkHistoryComponent implements OnInit {


  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  initForm: any;
  isfetching: boolean;



  months = [
    {name: 'January', value: 'January'},
    {name: 'February', value: 'February'},
    {name: 'March', value: 'March'},
    {name: 'April', value: 'April'},
    {name: 'May', value: 'May'},
    {name: 'June', value: 'June'},
    {name: 'July', value: 'July'},
    {name: 'August', value: 'August'},
    {name: 'September',  value: 'September'},
    {name: 'October',  value: 'October'},
    {name: 'November',  value: 'November'},
    {name: 'December',  value: 'December'}
  ];



  constructor() { }

  @Input() regForm: UntypedFormGroup;

  ngOnInit(): void {

    this.initForm = this.regForm;
    this.isfetching = false;

    this.noPriorClick(this.regForm.get('noemploy').value);



  }


  decreasePage() {
    this.pagecountevnt.emit(0);
  }






   step9Submitted(postValue: UntypedFormGroup) {

    const documentA = this.initForm;
    const documentB = postValue.value;


    // this.continueevnt.emit(postValue);

    // return true;


    this.regForm.get('noemployexp').markAsTouched();
    this.regForm.get('noemployexp').updateValueAndValidity();

    this.regForm.get('CO1AUTH').markAsTouched();
    this.regForm.get('CO1AUTH').updateValueAndValidity();

    this.regForm.get('CO1NAME').markAsTouched();
    this.regForm.get('CO1NAME').updateValueAndValidity();

    this.regForm.get('CO1FROMMTH1').markAsTouched();
    this.regForm.get('CO1FROMMTH1').updateValueAndValidity();

    this.regForm.get('CO1FROMYR').markAsTouched();
    this.regForm.get('CO1FROMYR').updateValueAndValidity();

    this.regForm.get('CO1TOMTH1').markAsTouched();
    this.regForm.get('CO1TOMTH1').updateValueAndValidity();

    this.regForm.get('CO1TOYR').markAsTouched();
    this.regForm.get('CO1TOYR').updateValueAndValidity();

    this.regForm.get('CO1ADD').markAsTouched();
    this.regForm.get('CO1ADD').updateValueAndValidity();

    this.regForm.get('CO1ADD2').markAsTouched();
    this.regForm.get('CO1ADD2').updateValueAndValidity();

    this.regForm.get('CO1POS').markAsTouched();
    this.regForm.get('CO1POS').updateValueAndValidity();

    this.regForm.get('SUPER').markAsTouched();
    this.regForm.get('SUPER').updateValueAndValidity();

    this.regForm.get('CO1PHONE').markAsTouched();
    this.regForm.get('CO1PHONE').updateValueAndValidity();

    this.regForm.get('CO1REASON').markAsTouched();
    this.regForm.get('CO1REASON').updateValueAndValidity();




    this.isSubmitted = true;
    if (!this.regForm.valid) {
      return false;
    } else {
      // the is the event property of the template emitting the validation value to the parent component
      this.isfetching = true;
      this.continueevnt.emit(postValue);
      this.pagecountevnt.emit(1);

      return true;
    }

   }


   isFetching(e) {
    this.isfetching = e; }

    noPriorClick(x) {

      if (x === true) {

        this.regForm.get('noemployexp').enable();

        this.regForm.get('CO1AUTH').disable();
        this.regForm.get('CO1AUTH').setValue('');
        this.regForm.get('CO1NAME').disable();
        this.regForm.get('CO1NAME').setValue('');
        this.regForm.get('CO1FROMMTH1').disable();
        this.regForm.get('CO1FROMMTH1').setValue('');
        this.regForm.get('CO1FROMYR').disable();
        this.regForm.get('CO1FROMYR').setValue('');
        this.regForm.get('CO1TOMTH1').disable();
        this.regForm.get('CO1TOMTH1').setValue('');
        this.regForm.get('CO1TOYR').disable();
        this.regForm.get('CO1TOYR').setValue('');
        this.regForm.get('CO1ADD').disable();
        this.regForm.get('CO1ADD').setValue('');
        this.regForm.get('CO1ADD2').disable();
        this.regForm.get('CO1ADD2').setValue('');
        this.regForm.get('CO1POS').disable();
        this.regForm.get('CO1POS').setValue('');
        this.regForm.get('SUPER').disable();
        this.regForm.get('SUPER').setValue('');
        this.regForm.get('CO1PHONE').disable();
        this.regForm.get('CO1PHONE').setValue('');
        this.regForm.get('CO1EMAIL').disable();
        this.regForm.get('CO1EMAIL').setValue('');
        this.regForm.get('CO1REASON').disable();
        this.regForm.get('CO1REASON').setValue('');


        this.regForm.get('CO2AUTH').disable();
        this.regForm.get('CO2AUTH').setValue('');
        this.regForm.get('CO2NAME').disable();
        this.regForm.get('CO2NAME').setValue('');
        this.regForm.get('CO2FROMMTH2').disable();
        this.regForm.get('CO2FROMMTH2').setValue('');
        this.regForm.get('CO2FROMYR').disable();
        this.regForm.get('CO2FROMYR').setValue('');
        this.regForm.get('CO2TOMTH2').disable();
        this.regForm.get('CO2TOMTH2').setValue('');
        this.regForm.get('CO2TOYR').disable();
        this.regForm.get('CO2TOYR').setValue('');
        this.regForm.get('CO2ADD').disable();
        this.regForm.get('CO2ADD').setValue('');
        this.regForm.get('CO2ADD2').disable();
        this.regForm.get('CO2ADD2').setValue('');
        this.regForm.get('CO2POS').disable();
        this.regForm.get('CO2POS').setValue('');
        this.regForm.get('SUPER2').disable();
        this.regForm.get('SUPER2').setValue('');
        this.regForm.get('CO2PHONE').disable();
        this.regForm.get('CO2PHONE').setValue('');
        this.regForm.get('CO2EMAIL').disable();
        this.regForm.get('CO2EMAIL').setValue('');
        this.regForm.get('CO2REASON').disable();
        this.regForm.get('CO2REASON').setValue('');



        this.regForm.get('CO3AUTH').disable();
        this.regForm.get('CO3AUTH').setValue('');
        this.regForm.get('CO3NAME').disable();
        this.regForm.get('CO3NAME').setValue('');
        this.regForm.get('CO3FROMMTH3').disable();
        this.regForm.get('CO3FROMMTH3').setValue('');
        this.regForm.get('CO3FROMYR').disable();
        this.regForm.get('CO3FROMYR').setValue('');
        this.regForm.get('CO3TOMTH3').disable();
        this.regForm.get('CO3TOMTH3').setValue('');
        this.regForm.get('CO3TOYR').disable();
        this.regForm.get('CO3TOYR').setValue('');
        this.regForm.get('CO3ADD').disable();
        this.regForm.get('CO3ADD').setValue('');
        this.regForm.get('CO3ADD2').disable();
        this.regForm.get('CO3ADD2').setValue('');
        this.regForm.get('CO3POS').disable();
        this.regForm.get('CO3POS').setValue('');
        this.regForm.get('SUPER3').disable();
        this.regForm.get('SUPER3').setValue('');
        this.regForm.get('CO3PHONE').disable();
        this.regForm.get('CO3PHONE').setValue('');
        this.regForm.get('CO3EMAIL').disable();
        this.regForm.get('CO3EMAIL').setValue('');
        this.regForm.get('CO3REASON').disable();
        this.regForm.get('CO3REASON').setValue('');
        this.regForm.get('WHAR').disable();
        this.regForm.get('WHAR').setValue('');


      } else {

        this.regForm.get('noemployexp').disable();
        this.regForm.get('noemployexp').setValue('');


        this.regForm.get('CO1AUTH').enable();
        this.regForm.get('CO1NAME').enable();
        this.regForm.get('CO1FROMMTH1').enable();
        this.regForm.get('CO1FROMYR').enable();
        this.regForm.get('CO1TOMTH1').enable();
        this.regForm.get('CO1TOYR').enable();
        this.regForm.get('CO1ADD').enable();
        this.regForm.get('CO1ADD2').enable();
        this.regForm.get('CO1POS').enable();
        this.regForm.get('SUPER').enable();
        this.regForm.get('CO1PHONE').enable();
        this.regForm.get('CO1EMAIL').enable();
        this.regForm.get('CO1REASON').enable();


        this.regForm.get('CO2AUTH').enable();
        this.regForm.get('CO2NAME').enable();
        this.regForm.get('CO2FROMMTH2').enable();
        this.regForm.get('CO2FROMYR').enable();
        this.regForm.get('CO2TOMTH2').enable();
        this.regForm.get('CO2TOYR').enable();
        this.regForm.get('CO2ADD').enable();
        this.regForm.get('CO2ADD2').enable();
        this.regForm.get('CO2POS').enable();
        this.regForm.get('SUPER2').enable();
        this.regForm.get('CO2PHONE').enable();
        this.regForm.get('CO2EMAIL').enable();
        this.regForm.get('CO2REASON').enable();



        this.regForm.get('CO3AUTH').enable();
        this.regForm.get('CO3NAME').enable();
        this.regForm.get('CO3FROMMTH3').enable();
        this.regForm.get('CO3FROMYR').enable();
        this.regForm.get('CO3TOMTH3').enable();
        this.regForm.get('CO3TOYR').enable();
        this.regForm.get('CO3ADD').enable();
        this.regForm.get('CO3ADD2').enable();
        this.regForm.get('CO3POS').enable();
        this.regForm.get('SUPER3').enable();
        this.regForm.get('CO3PHONE').enable();
        this.regForm.get('CO3EMAIL').enable();
        this.regForm.get('CO3REASON').enable();
        this.regForm.get('WHAR').enable();

      }
    }



}
